import { BaseLayout } from '~/src/components/shared/layout'
import { CategoryTitle } from '~/src/components/shared'
import { FestivalNavigation, FestivalBanner, PageTitle, FestivalPostGrid } from '~/src/components/festival'
import { FestivalPosition } from '~/src/generated/graphql'
import { FESTIVAL_EXTRAS_CATEGORY } from '~/src/const'
import { FestivalContextProvider } from '~/src/contexts'

export default function ExtrasPage() {

  return (
    <BaseLayout>
      <FestivalContextProvider>
        <FestivalNavigation />
        <FestivalBanner position={FestivalPosition.Extras} />
        <CategoryTitle categoryId={FESTIVAL_EXTRAS_CATEGORY} />
        <FestivalPostGrid categoryId={FESTIVAL_EXTRAS_CATEGORY} />
      </FestivalContextProvider>
    </BaseLayout>
  )
}
